module.exports = __webpack_public_path__ + "img/2-6.20ed71a0.png";